/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import { Maybe } from '@irian-ro/util-functions';

export class DriverVoModel extends JSONable {
  uuid: Maybe<string> | undefined = undefined;
  name: Maybe<string> | undefined = undefined;
  description: Maybe<string> | undefined = undefined;
  phoneNumber: Maybe<string> | undefined = undefined;

  constructor(uuid?: string, name?: string, description?: string, phoneNumber?: string) {
    super();
    this.uuid = uuid;
    this.name = name;
    this.description = description;
    this.phoneNumber = phoneNumber;
  }
}
